import { layerSource } from './Types';

import { Map } from './Map';

import { FeatureLayer } from './FeatureLayer';

import { FilterSpecification } from 'maplibre-gl';

export class LineVectorLayer extends FeatureLayer {
  constructor(
    layerSource: layerSource,
    mapObj: Map,
    sourceLayerId?: string,
    layerId?: string,
    sourceId?: string
  ) {
    super(layerSource, mapObj, sourceLayerId, layerId, sourceId);
  }

  addOutLine = (color: string = 'red', width: number = 3, gap: number = 1) => {

    let parentFilter = this.getFilter()

    if (Number(this.mapObj.getPaintProperty(this.layerId, 'line-width')) > width){
       width = Number(this.mapObj.getPaintProperty(this.layerId, 'line-width')) + 1
    }

    if (this.mapObj.getLayer(`${this.layerId}$outline`)) {
      this.mapObj.setPaintProperty(
        `${this.layerId}$outline`,
        'line-color',
        color
      );
      this.mapObj.setPaintProperty(
        `${this.layerId}$outline`,
        'line-width',
        width
      );
      this.mapObj.setPaintProperty(
        `${this.layerId}$outline`,
        'line-gap-width',
        gap
      );
    } else {
      this.mapObj.addLayer({
        id: `${this.layerId}$outline`,
        type: 'line',
        source: this.sourceId,
        'source-layer': this.sourceLayer,
        paint: {
          'line-color': color,
          'line-width': width,
          'line-gap-width': gap,
        },
      });
    }
    this._setLayerProperty('maxzoom',this.mapObj.getLayer(this.layerId)?.maxzoom ,'outline');
    this._setLayerProperty('minzoom',this.mapObj.getLayer(this.layerId)?.minzoom ,'outline');

    this.setSubLayerFilter(<FilterSpecification>parentFilter,'outline');

    // let newOrder = this.mapObj.style._order.indexOf(this.layerId);
    this.mapObj.moveLayerOrder(`${this.layerId}$outline`, this.layerId);
    // this.mapObj.moveLayerOrder(this.layerId, `${this.layerId}$outline`);
    this.mapObj.moveLayerOrder('geobox-gl-splash-circle');
    // if (visibility === 'none') {
    //   this.mapObj.setLayoutProperty(
    //     `${this.layerId}$outline`,
    //     'visibility',
    //     'none'
    //   );
    // }
  };
}
